import React from "react";
import "../css/About.css";
import school from "../asset/school.png";
import maruti from "../asset/Maruti U Gaikar.png";
import swapnil from "../asset/Swapnil M Gaikar.png";
import pranal from "../asset/Pranal M Gaikar.png";
import history from "../asset/history.png";
import mission from "../asset/mission vision.png";
import Principal from "./Principal";

const About = () => {
  return (
    <div>
      {/* About Section */}
      <section className="about-main">
        <div className="container">
          <div className="row">
            <h3 className="heading">About SMG</h3>
            <p className="slogan">
              Embark on a Journey of Excellence with SMG English School
            </p>
            <p className="about-para">
              Founded in 1993 by the visionary{" "}
              <span className="highlighted-text">Shri. Maruti U. Gaikar</span>,
              SMG English School proudly stands as the first English medium
              school in Diva, setting a golden standard in education. Operating
              under the esteemed Om Sai Shikshan Sanstha since 1998, SMG began
              its mission with just 36 pre-primary students in Dativali village.
              Today, it has flourished into a beacon of academic excellence and
              holistic development. At SMG, education transcends academics. We
              focus on nurturing well-rounded individuals by fostering
              creativity, social consciousness, emotional intelligence,
              intellectual curiosity, and physical well-being. Our approach
              equips students with a strong academic foundation and essential
              life skills, cultivating a lifelong love for learning. With over{" "}
              <span className="highlighted-text">25 years of excellence</span>,
              SMG English School continues to inspire generations, earning
              accolades across all domains of development. Join us as we move
              forward with passion and purpose, shaping a future of endless
              possibilities and success.
            </p>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className="history">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="history-text">
                <h4 className="heading-large">SMG History</h4>
                <p className="history-para">
                  Rooted in a humble pre-primary establishment, our school has
                  steadily flourished, laying each brick with meticulous care
                  and dedication. Over the years, we have evolved into a
                  distinguished and esteemed learning hub, attracting students
                  from Nursery to Grade 12. Situated proudly among the eminent
                  SSC schools in Diva, we remain steadfast in our commitment to
                  offering a transformative and enriching educational journey.
                </p>
                <p className="history-para">
                  Aligned with the Maharashtra State Board, we take pride in our
                  first batch of students who embarked on their SSC examinations
                  in March 2006, marking a significant milestone in our
                  educational legacy. With an unwavering focus on delivering an
                  enjoyable and purposeful learning experience, we continue to
                  raise the bar in academic excellence and holistic development,
                  nurturing the minds and hearts of our students to thrive in a
                  dynamic world.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <img
                className="about-img"
                src={history}
                alt="SMG School History"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Merged Mission & Vision Section */}
      <section className="mission_vision">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <img
                className="about-img"
                src={mission}
                alt="SMG School Mission and Vision"
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h4 className="heading large">SMG Mission & Vision</h4>
              <p className="history-para">
                At SMG School, we nurture independent thinkers and responsible
                citizens, valuing diverse perspectives, intellectual humility,
                and respect for nature and culture. We blend Indian traditions
                with a global outlook, instilling social responsibility,
                discipline, empathy, and integrity. Our goal is to inspire a
                lifelong desire to serve humanity and shape compassionate global
                citizens who contribute meaningfully to society.
              </p>
              <p className="history-para">
                SMG School envisions a vibrant, safe learning environment where
                students thrive academically and personally. We instill empathy,
                respect, and discipline, empowering students to navigate life
                with integrity. Our goal is to prepare global citizens with the
                skills and mindset to excel in a connected world, cultivating
                future leaders who inspire change and build a better tomorrow.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
